import {
  ENLARGE_IMAGE,
  SET_FILTER_DATA,
  GROUPING_TREE_DATA,
  SELECTED_TCIN_DATA,
  SELECTED_FILTER_TCINS,
  DATA_FILTERED,
  TREE_LIST_DATA,
  USER_FILTERS,
  SET_MAX_ALT_IMAGE_COUNT,
  SET_SHOW_CONTENT,
  SET_ERROR_TYPE,
  SET_ERROR_LIST,
  SET_COLUMN_MAP,
  SET_TEMP_COLUMN_MAP,
  SET_LAYOUT,
  SET_USER_COL_MAP,
  SET_CUSTOMIZED_VIEW,
  SET_APPLIED_VIEW,
  SET_IS_APPLY_DISABLED,
  SET_IS_SAVE_DISABLED,
  SET_TEMP_LAYOUT,
} from './actionTypes'
import {
  columnMap,
  altImageData,
  altSourceImageData,
} from '../../containers/TcinInfo/constants'
import { cloneDeep, compact, orderBy, uniq } from 'lodash'
import { createFilterData } from '../../helpers/filter'
import TreeNode from '../../containers/TcinInfo/TreeNode'
import {
  expandRelationshipService,
  generatePDFAPIService,
  getTcinDataService,
  generateContactSheetPDFAPIService,
  generateContactSheetFinalPDFAPIService,
  generateContactSheetStoresPDFAPIService,
  generateCompactShotSheetPDFAPIService,
  setSaveUserColumnsService,
  getUserViewDataService,
} from '../../services/tcinInfoService'

export const setSortedTcinData = (data, appendingData = false) => {
  return async (dispatch, getState) => {
    const state = getState().tcinPhotoInfoReducer
    let newFilters
    if (appendingData) {
      newFilters = createFilterData(data, state.filters)
      dispatch(updateUserFilters(newFilters))
      dispatch(appendToTree(data))
    } else {
      newFilters = createFilterData(data)
      dispatch(createTree(data))
    }
    dispatch(setFilters(newFilters))
    dispatch(setSelected([]))
  }
}

export const createTree = (data) => {
  return async (dispatch, getState) => {
    let newRoot = new TreeNode('root')
    let newMap = new Map()

    data.forEach((o) => {
      let child = new TreeNode(o)
      newRoot.addChild(child)
      newMap.set(child.tcin, child)
    })

    let newTree = {
      treeNode: newRoot,
      treeMap: newMap,
    }

    dispatch(setTreeData(newTree))
    let newList = []
    createRowList(newTree.treeNode, newTree.treeMap, 0, newList)
    dispatch(setTreeList(newList))
  }
}

export const appendToTree = (data) => {
  return async (dispatch, getState) => {
    let treeData = cloneDeep(getState().tcinPhotoInfoReducer.tree)
    let selected = cloneDeep(getState().tcinPhotoInfoReducer.selected)
    let newRoot = treeData.treeNode
    let newMap = treeData.treeMap
    selected.forEach((o) => {
      let oNode = o

      oNode?.parentsData?.forEach((parent) => {
        if (!oNode.parents.some((t) => t === parent)) {
          let parentTcin = data.find((o) => o.tcin === parent)
          if (parentTcin) {
            let foundParent = newMap.get(parent)

            if (foundParent === undefined) {
              let newParent = new TreeNode(parentTcin)
              newRoot.addChild(newParent)
              newParent.addChild(oNode)
              newMap.set(newParent.tcin, newParent)
              newMap.set(oNode.tcin, oNode)
            } else {
              foundParent.addChild(oNode)
              newMap.set(foundParent.tcin, foundParent)
              newMap.set(oNode.tcin, oNode)
            }
            newRoot.removeChild(oNode)
          }
        }
      })

      oNode?.childrenData?.forEach((child) => {
        if (!oNode.children.some((t) => t === child)) {
          let childNode = data.find((o) => o.tcin === child)
          if (childNode) {
            let foundChild = newMap.get(child)
            if (foundChild === undefined) {
              let newChild = new TreeNode(childNode)
              oNode.addChild(newChild)
              newMap.set(newChild.tcin, newChild)
              newMap.set(oNode.tcin, oNode)
            } else {
              oNode.addChild(foundChild)
              newMap.set(oNode.tcin, oNode)
              newMap.set(foundChild.tcin, foundChild)
              if (foundChild.parents.some((t) => t === 'root')) {
                newRoot.removeChild(foundChild)
              }
            }
          }
        }
      })
    })
    newMap.set(newRoot.tcin, newRoot)
    let newTree = {
      treeNode: newRoot,
      treeMap: newMap,
    }
    dispatch(setTreeData(newTree))
    let newList = []
    createRowList(newTree.treeNode, newTree.treeMap, 0, newList)
    dispatch(setTreeList(newList))
  }
}

const createRowList = (tree, treeMap, level = 0, list) => {
  if (tree.children.length !== 0) {
    tree.children.forEach((tcin, i) => {
      let node = treeMap.get(tcin)
      let obj = {
        level: level,
        node: node,
      }
      list.push(obj)
      createRowList(node, treeMap, level + 1, list)
    })
  }
}

const updateUserFilters = (globalFilter) => {
  return async (dispatch, getState) => {
    // let newFilterData = cloneDeep(filterData)
    let filterWithTcins = {}
    Object.entries(getState().tcinPhotoInfoReducer.userFilters).forEach(
      ([key, value]) => {
        // newFilterData[key].userSelected = value
        if (value.length > 0) {
          filterWithTcins[key] = []
          Object.entries(globalFilter[key].values).forEach(([k, v]) => {
            if (value.includes(k)) {
              filterWithTcins[key].push(...v)
            }
          })
        }
      }
    )
    let tcins = Object.values(filterWithTcins)
    let filtered = compact(
      uniq(
        tcins.reduce(
          (previousValue, currentValue) =>
            currentValue.filter((c) => previousValue.includes(c)),
          tcins[0] ?? []
        )
      )
    )
    dispatch(
      setFilteredTCINList([
        ...getState().tcinPhotoInfoReducer.filteredTCINS,
        ...filtered,
      ])
    )
  }
}

export const generatePDFAPI = (
  tcins,
  accessToken,
  progressCallBack = () => {}
) => {
  return async (dispatch, getState) => {
    generatePDFAPIService(tcins, accessToken, progressCallBack)
      .then((response) => {
        var file = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {})
  }
}

export const getTcinDataAction = (tcins, studio = '', accessToken) => {
  return async (dispatch, getState) => {
    let request = {
      id_list: tcins,
    }
    getTcinDataService(studio, request, accessToken)
      .then((res) => {
        const {
          data: { max_alt_count = 0, tcin_info = [], errors = [] } = {},
        } = res
        dispatch(setMaxAltCount(max_alt_count || 0))
        dispatch(setSortedTcinData(tcin_info))
        if (tcin_info.length > 0) {
          dispatch(setShowContent('table'))
        } else {
          dispatch(setShowContent('blank'))
        }
        if (errors.length > 0) {
          dispatch(setErrorType('invalid'))
          dispatch(setErrorList(errors))
        } else {
          dispatch(setErrorType('success'))
        }
      })
      .catch((e) => {
        dispatch(setErrorType('error'))
        dispatch(setShowContent('blank'))
      })
  }
}

export const generateContactSheetPDFAPI = (
  tcins,
  accessToken,
  progressCallBack = () => {}
) => {
  return async (dispatch, getState) => {
    generateContactSheetPDFAPIService(tcins, accessToken, progressCallBack)
      .then((response) => {
        var file = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {})
  }
}
export const generateContactSheetFinalPDFAPI = (
  tcins = '',
  accessToken = '',
  progressCallBack = () => {},
  dpci = ''
) => {
  return async (dispatch, getState) => {
    generateContactSheetFinalPDFAPIService(
      tcins,
      accessToken,
      progressCallBack,
      dpci
    )
      .then((response) => {
        var file = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {})
  }
}

export const generateContactSheetStoresPDFAPI = (
  dpci = '',
  accessToken = '',
  progressCallBack = () => {}
) => {
  return async (dispatch, getState) => {
    generateContactSheetStoresPDFAPIService(dpci, accessToken, progressCallBack)
      .then((response) => {
        var file = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {})
  }
}

export const generateCompactShotSheetPDFAPI = (
  tcins = '',
  accessToken = '',
  progressCallBack = ''
) => {
  return async (dispatch, getState) => {
    generateCompactShotSheetPDFAPIService(tcins, accessToken, progressCallBack)
      .then((response) => {
        var file = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      })
      .catch((error) => {})
  }
}

export function setFilters(data) {
  return {
    type: SET_FILTER_DATA,
    payload: data,
  }
}

function setTreeData(data) {
  return {
    type: GROUPING_TREE_DATA,
    payload: data,
  }
}

export function setTreeList(data) {
  return {
    type: TREE_LIST_DATA,
    payload: data,
  }
}

export function setFilteredTCINList(data) {
  return {
    type: SELECTED_FILTER_TCINS,
    payload: data,
  }
}

export function setMaxAltCount(data) {
  return {
    type: SET_MAX_ALT_IMAGE_COUNT,
    payload: data,
  }
}

export function setShowContent(data) {
  return {
    type: SET_SHOW_CONTENT,
    payload: data,
  }
}

export function setErrorType(data) {
  return {
    type: SET_ERROR_TYPE,
    payload: data,
  }
}

export function setErrorList(data) {
  return {
    type: SET_ERROR_LIST,
    payload: data,
  }
}

export function setSelected(data) {
  return {
    type: SELECTED_TCIN_DATA,
    payload: data,
  }
}
export function setDataFiltered(data) {
  return {
    type: DATA_FILTERED,
    payload: data,
  }
}
export function setUserFilters(data) {
  return {
    type: USER_FILTERS,
    payload: data,
  }
}

export function setColumnMap(data) {
  return {
    type: SET_COLUMN_MAP,
    payload: data,
  }
}

export function setTempColumnMap(data) {
  return {
    type: SET_TEMP_COLUMN_MAP,
    payload: data,
  }
}

export function setLayout(data) {
  return {
    type: SET_LAYOUT,
    payload: data,
  }
}

export function setTempLayout(data) {
  return {
    type: SET_TEMP_LAYOUT,
    payload: data,
  }
}

export function setUserColumnMap(data) {
  return {
    type: SET_USER_COL_MAP,
    payload: data,
  }
}

export function setCustomizedView(data) {
  return {
    type: SET_CUSTOMIZED_VIEW,
    payload: data,
  }
}

export function setAppliedView(data) {
  return {
    type: SET_APPLIED_VIEW,
    payload: data,
  }
}

export function setIsApplyDisabled(data) {
  return {
    type: SET_IS_APPLY_DISABLED,
    payload: data,
  }
}

export function setIsSaveDisabled(data) {
  return {
    type: SET_IS_SAVE_DISABLED,
    payload: data,
  }
}

export function openZoomedImage(
  title,
  imageSrc,
  tableName = '',
  fileName = '',
  imageUrl = '',
  originalVersion = '',
  imageStatus = '',
  imageVersion = '',
  uploadedVersion = ''
) {
  let data = {
    open: true,
    title: title,
    src: imageSrc,
    fileName: fileName,
    imageUrl: imageUrl,
    tableName: tableName,
    originalVersion,
    imageStatus,
    imageVersion,
    uploadedVersion,
  }

  return {
    type: ENLARGE_IMAGE,
    payload: data,
  }
}

export function closeZoomedImage() {
  let data = {
    open: false,
    title: '',
    src: '',
    fileName: '',
    imageUrl: '',
  }
  return {
    type: ENLARGE_IMAGE,
    payload: data,
  }
}

const applyUserView = (data) => {
  return async (dispatch, getState) => {
    let altCols = []
    let altSourceCols = []
    const {
      tcinPhotoInfoReducer: { maxAltImageCount = '', columnMap = [] } = {},
    } = getState()

    for (var i = 0; i < maxAltImageCount; i++) {
      altCols = [...altCols, ...altImageData(i)]
      altSourceCols = [...altSourceCols, ...altSourceImageData(i)]
    }
    let sortedColMap = orderBy(
      [...columnMap, ...altCols, ...altSourceCols],
      ['colOrder'],
      ['asc']
    )
    let indices = data.reduce((s, t, u) => {
      return s.concat(
        sortedColMap.reduce((r, v, i) => {
          return r.concat(v.groupId === t ? i : [])
        }, [])
      )
    }, [])
    let updatedColMap = sortedColMap.map((u) =>
      u.groupId !== 'tcin' || u.groupId !== 'relationship_type'
        ? { ...u, selected: false }
        : u
    )
    indices.forEach((index) => {
      if (updatedColMap[index].isParent) {
        let indexMap = updatedColMap.reduce((r, v, i) => {
          return r.concat(v.parentId === updatedColMap[index].groupId ? i : [])
        }, [])
        indexMap.forEach((o) => {
          let sibling = updatedColMap.find(
            (i) =>
              i.groupId === updatedColMap[o].groupId &&
              i.custColType === 'checkbox'
          )
          updatedColMap[o] = {
            ...updatedColMap[o],
            selected: sibling?.selected || false,
          }
        })
        updatedColMap[index] = {
          ...updatedColMap[index],
          selected: true,
        }
      } else if (updatedColMap[index].parentId !== undefined) {
        let parent = updatedColMap.find(
          (i) => i.groupId === updatedColMap[index].parentId
        )
        updatedColMap[index] = {
          ...updatedColMap[index],
          selected: parent.selected,
        }
      } else {
        if (updatedColMap[index].groupId === 'layout') {
          dispatch(setLayout(updatedColMap[index].selected ? 'flat' : 'nested'))
        }
        updatedColMap[index] = {
          ...updatedColMap[index],
          selected: true,
        }
      }
    })
    dispatch(setTempColumnMap(updatedColMap))
    dispatch(setColumnMap(updatedColMap))
    dispatch(setUserColumnMap(updatedColMap))
    dispatch(setCustomizedView('Userbased'))
    dispatch(setAppliedView('Userbased'))
    dispatch(setIsApplyDisabled(true))
  }
}

const handleNoUserView = () => {
  return async (dispatch, getState) => {
    dispatch(setCustomizedView('Userbased'))
    dispatch(setAppliedView('Userbased'))
    dispatch(setIsSaveDisabled(false))
  }
}

export const expandRelationship = (request, accessToken) => {
  return async (dispatch, getState) => {
    expandRelationshipService(request, accessToken)
      .then((res) => {
        const { data: { tcin_info = [] } = {} } = res
        dispatch(setSortedTcinData(tcin_info, true))
      })
      .catch((e) => {
        console.error('Error in expandRelationship:', e)
      })
  }
}

export const getUserViewData = (lanId) => {
  return async (dispatch, getState) => {
    getUserViewDataService(lanId)
      .then((res) => {
        const { data: { column_list = [] } = {} } = res
        column_list?.length
          ? dispatch(applyUserView(column_list))
          : dispatch(handleNoUserView())
      })
      .catch((error) => {
        console.error(
          'There is an error while fetching the custom columns list',
          error
        )
      })
  }
}

export const setSaveUserColumns = (request, accessToken) => {
  return async (dispatch, getState) => {
    const {
      tcinPhotoInfoReducer: { tempColMap = columnMap, tempLayout = [] } = {},
    } = getState()
    setSaveUserColumnsService(request, accessToken)
      .then((res) => {
        dispatch(setUserColumnMap(tempColMap))
        dispatch(setLayout(tempLayout))
        dispatch(setColumnMap(tempColMap))
        dispatch(setIsSaveDisabled(true))
        dispatch(setIsApplyDisabled(true))
      })
      .catch((error) => {
        console.error(
          'There is an error while saving the custom columns list',
          error
        )
      })
  }
}
